import React from 'react'
import { observer } from 'mobx-react'
import { AnimatePresence, motion } from 'framer-motion'
import campaignInviteStore from '../../../mobx/campaignInvite'

// Barre d'action flottante affichee quand au moins un createur est selectionne
// dans la galerie. Permet de lancer l'invitation groupee ou de vider la selection.
const InviteBar: React.FC = () => {
  const count = campaignInviteStore.count

  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.div
          className="fixed bottom-6 left-1/2 z-[900] -translate-x-1/2"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ type: 'spring', stiffness: 300, damping: 26 }}
        >
          <div
            className="flex items-center gap-3 rounded-full py-2 pl-5 pr-2 text-white shadow-xl"
            style={{ background: 'linear-gradient(135deg, #7885ed, #b06ef0)' }}
          >
            <span className="text-sm font-semibold">
              {count} créateur{count > 1 ? 's' : ''} sélectionné{count > 1 ? 's' : ''}
            </span>
            <button
              type="button"
              onClick={() => campaignInviteStore.clear()}
              className="text-xs text-white/80 underline hover:text-white"
            >
              Tout retirer
            </button>
            <button
              type="button"
              onClick={() => campaignInviteStore.openModal()}
              className="flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-bold text-[#7885ed] hover:opacity-90"
            >
              <i className="fa-solid fa-paper-plane" />
              Inviter à une campagne
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default observer(InviteBar)
